export enum SongModalPages {
    Save,
    ConfirmDeletion,
  }